var _path, _path2, _rect, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.75V11.75C12.75 11.2196 12.592 10.7109 12.3107 10.3358C12.0294 9.96071 11.6478 9.75 11.25 9.75H8.25C7.85218 9.75 7.47064 9.96071 7.18934 10.3358C6.90804 10.7109 6.75 11.2196 6.75 11.75V12.75",
    stroke: "#1977d2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.25C10.5784 8.25 11.25 7.57843 11.25 6.75C11.25 5.92157 10.5784 5.25 9.75 5.25C8.92157 5.25 8.25 5.92157 8.25 6.75C8.25 7.57843 8.92157 8.25 9.75 8.25Z",
    stroke: "#1977d2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.375,
    y: 1.5,
    width: 12,
    height: 15,
    rx: 1.25,
    stroke: "#1977d2",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 3.375H4.5",
    stroke: "#1977d2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 7.125H4.5",
    stroke: "#1977d2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 10.875H4.5",
    stroke: "#1977d2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 14.625H4.5",
    stroke: "#1977d2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContacts);
export default __webpack_public_path__ + "static/media/icon-contacts.f2e27f90b6e5c00bce7b116baf50de8a.svg";
export { ForwardRef as ReactComponent };